module.exports = "https://99designs-start-assets.imgix.net/js/ff439c265fe5166af4a7fcaaf9af7db0.png";